import React, { useState, useEffect } from "react";
import { Box, Input, Button, Modal, toastEmitter, Toast, ReactSelect } from "@anchor/react-components";
import SubscriptionCodeTable from './SubscriptionCodeTable.js';
import axios from "axios";
import CONSTANTS from './SubscriptionConstants.js';
import { accessRequest } from './authConfig';
import useFetchWithMsal from './hooks/useFetchWithMsal';

function SubscriptionCode() {
    const { error, execute } = useFetchWithMsal(accessRequest);

    const [code, setCode] = useState('');
    const [value, setValue] = useState('');
    const [type, setType] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);

    const [counter, setCounter] = useState(0);
    const [filterType, setFilterType] = useState([]);

    const [isAuthorized, setAuthorized] = useState(true);
    const [showAuthModal, setAuthModal] = useState('');

    const containerStyle = {
        margin: "5px",
    };

    const boxStyle = {
        justifyContent: "center",
        alignItems: "center", // Center vertically
        flexDirection: "column",
        width: "100%", // Set width to 100%
        background: "#fff",
        marginBottom: "20px",
    };

    const buttonBoxStyle = {
        justifyContent: "center",
        alignItems: "center", // Center vertically
        marginTop: "20px",
        marginBottom: "20px",
        width: "100%", // Set width to 100%
    };

    const fetchCodeType = async () => {
        try {
            const urlstr = CONSTANTS.UI_BACKEND_BASE_URL + `/v1/subscriptionCode/getType`;
            console.log(urlstr);
            execute("GET", urlstr).then((response) => {
                if (response) {
                    if (response.status !== 401 && response.status !== 403) {
                        setFilterType(response);
                    } else {
                        setAuthModal(true);
                        setAuthorized(false);
                    }
                }
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchCodeType();
    }, [execute]);

    const mappedData = filterType?.map(item => ({
        id: item.filterType,
        label: item.filterType,
        value: item.filterType
    }));

    const handleSelectChange = (option) => {
        setSelectedOption(option);
        setType(option ? option.value : '');
    };

    const handleResetButtonClick = async () => {
        setCode('');
        setValue('');
        setType('');
        setSelectedOption(null);
        setCounter(0);
    }

    const handleFindButtonClick = async () => {
        setCounter(counter + 1);
    }

    const handleCreateButtonClick = async () => {
        if (!code) {
            toastEmitter({ "title": "ALERT", "description": "Code Name is missing, please provide value in Code Name field" }, { position: 'top-center' });
            return;
        }
        if (!type) {
            toastEmitter({ "title": "ALERT", "description": "Code Type is missing, either choose Code Type from drop down or create new." }, { position: 'top-center' });
            return;
        }

        // Construct payload using user-entered values
        const payload = {
            code,
            value,
            type,
        };

        try {
            const urlstr = CONSTANTS.UI_BACKEND_BASE_URL + `/v1/subscriptionCode/save`;
            console.log(urlstr);

            execute("POST", urlstr, payload).then((response) => {
                if (response) {
                    if (response.status === 'OK') {
                        console.log('API call successful');
                        toastEmitter({ "title": "SUCCESS", "description": response.message }, { position: 'top-center' })
                        setCounter(counter + 1);
                    } else {
                        if (response.status === 403) {
                            toastEmitter({ "title": "ERROR", "description": 'You are not authorized to create Subscription Code(s).' }, { position: 'top-center', type: "error" });
                        } else {
                            toastEmitter({ "title": "ERROR", "description": response.message }, { position: 'top-center', type: "error" });
                        }
                    }
                }
            });
        } catch (error) {
            console.error('Error during API call:', error);
        }
    };

    return (
        <div style={containerStyle}>
            <Box display="grid" gridTemplateColumns="1fr 1fr" gridGap={1.5} style={buttonBoxStyle}  >
                <Box p={2} borderColor="border.default" borderWidth={1} >
                    <Input
                        fit="small"
                        id="codeInput"
                        label="Code Name"
                        maxLength={50}
                        placeholder="Enter your code"
                        required
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        variant="default"
                    />
                </Box>
                <Box p={2} borderColor="border.default" borderWidth={1} >
                    <Input
                        fit="small"
                        id="valueInput"
                        label="Value"
                        maxLength={100}
                        placeholder="Enter your value"
                        type="text"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        variant="default"
                    />
                </Box>
                <Box p={2} borderColor="border.default" borderWidth={1}>
                    <ReactSelect
                        className="react-select"
                        closeMenuOnSelect
                        customNoOptionsMessage={<p>Not a valid option</p>}
                        defaultOptions={mappedData}
                        errorMessage="This is error message"
                        fit="small"
                        hintPosition="left"
                        id="codeType"
                        isAsync
                        isClearable
                        isCreatableOptions
                        label="Code Type"
                        name="codeType"
                        value={selectedOption}
                        onChange={handleSelectChange}
                        options={mappedData}
                        orientation="vertical"
                        placeholder="Select a code type"
                        required
                        suggestType="static"
                        tooltipDescription="Select or Create Code Type"
                        variant="default"
                        width={100}
                    />
                </Box>
            </Box>
            <div style={boxStyle}>
                <Button
                    disabled={!isAuthorized}
                    appearance="default"
                    id="primary2"
                    label="FIND"
                    width="32"
                    name="primary2"
                    onClick={handleFindButtonClick}
                    title="FIND"
                    variant="filledAlt"
                    fit="small"
                />
                &nbsp;&nbsp;
                <Button
                    disabled={!isAuthorized}
                    appearance="default"
                    id="primary"
                    label="CREATE"
                    width="32"
                    name="primary"
                    onClick={handleCreateButtonClick}
                    title="CREATE"
                    variant="filledAlt"
                    fit="small"
                />
                &nbsp;&nbsp;
                <Button
                    disabled={!isAuthorized}
                    appearance="default"
                    id="primary3"
                    label="RESET FIELDS"
                    width="32"
                    name="primary3"
                    onClick={handleResetButtonClick}
                    title="RESET"
                    variant="filled"
                    fit="small"
                />
            </div>

            {counter !== 0 ? <SubscriptionCodeTable code={code} value={value} type={type} counter={counter} /> : ''}

            <Toast />

            <Modal
                actions={{
                    primaryAction: <Button label="Ok" onClick={function noRefCheck() { setAuthModal('') }} variant="outlined" />
                }}
                heading="Alert"
                dimension="small"
                open={showAuthModal}
                showCloseIcon
                onClose={function noRefCheck() { setAuthModal('') }}
            >
                <p>
                    You are not authorized to work on this application.
                </p>
            </Modal>
        </div>
    );
}

export default SubscriptionCode;
